<template>
  <div class="wrapper">
    <div class="main visual-3">
      <Header backRoute="/appointments" />
      <h2>Identify Yourself?</h2>
      <div class="row">
        <div class="col-lg-2 col-md-4 col-sm-6"></div>
        <div class="col-lg-4 col-md-4 col-sm-6">
          <router-link
            :to="{ path: 'scanqr', query: { code: $route.query.code } }"
          >
            <div class="opt-1">
              <h4>Mamabots App</h4>
              <img src="@/assets/img/opt-1-img.png" alt="" />
              <!-- <p>
                Select this option if you have registered with us before and have
                installed our Matacs App for a fast and secure check-in process.
              </p> -->
            </div>
          </router-link>
        </div>
        <!-- <div class="col-lg-4 col-md-4 col-sm-6">
          <router-link :to="{ path: 'enter-phone', query: { code: $route.query.code } }">

            <div class="opt-1">
              <h4>SMS</h4>
              <img src="@/assets/img/opt-2-img.png" alt="" />
            </div>
          </router-link>
        </div> -->
        <div class="col-lg-4 col-md-4 col-sm-6">
          <router-link
            :to="{ path: '/enter-name', query: { code: $route.query.code } }"
          >
            <div class="opt-1">
              <h4>Fill Manually</h4>
              <img src="@/assets/img/opt-3-img.png" alt="" />
              <!-- <p>
                Use this option if you have not registered with us before by filling in
                your detailed information.
              </p> -->
            </div>
          </router-link>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-6"></div>
      </div>
      <FooterView />
    </div>
  </div>
</template>

<script>
import FooterView from "@/layout/Footer.vue";
import Header from "@/layout/Header.vue";
export default {
  components: {
    FooterView,
    Header,
  },
  name: "ChoseOption",
};
</script>
